import useCustomFieldsHook from "@/hooks/use-custom-fields.hook";
import { ApiHiringFlowField } from "@/types/hiring-flow.types";
import { Draggable } from "@hello-pangea/dnd";
import { DropdownMenuItem, FontAwesomeIcon, Stack, Switch, Tag, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { HiringFlowRowMenu } from "@/pages/settings/hiring-flows/edit/components/HiringFlowRowMenu";

export function HiringFlowFieldRow({
  field,
  index,
  disabled,
  onChange,
}: {
  field: ApiHiringFlowField;
  index: number;
  disabled: boolean;
  onChange: (changes: Partial<ApiHiringFlowField>) => void;
}) {
  const { t } = useTranslation();
  const { getFieldTitle } = useCustomFieldsHook();

  return (
    <Draggable draggableId={`field-${field.field.slug}`} index={index} isDragDisabled={disabled}>
      {(provided) => (
        <div ref={provided.innerRef} {...provided.draggableProps}>
          <Stack
            {...provided.dragHandleProps}
            direction="horizontal"
            items="center"
            gap="md"
            className={twMerge(
              "group min-h-14 py-3 pl-3 border-b border-dark/10 bg-light",
              !disabled && "cursor-grab"
            )}
          >
            <Stack className={"w-7 shrink-0"} items={"center"} justify={"center"}>
              <Switch
                size={"sm"}
                checked={field.is_enabled}
                disabled={disabled}
                onChange={(is_enabled) =>
                  onChange({ is_enabled, is_mandatory: is_enabled && field.is_mandatory })
                }
              />
            </Stack>
            <Title
              header={getFieldTitle(field.field)}
              size={"sm"}
              variant={field.is_enabled ? "default" : "secondary"}
            />
            {field.is_mandatory && (
              <Tag variant="secondary">{t("custom_fields:badge_mandatory")}</Tag>
            )}
            <div className="grow" />
            {!disabled && (
              <HiringFlowRowMenu>
                {field.is_enabled && (
                  <DropdownMenuItem
                    title={t(
                      field.is_mandatory
                        ? "hiring_flow:make_optional"
                        : "hiring_flow:make_mandatory"
                    )}
                    onClick={() => onChange({ is_mandatory: !field.is_mandatory })}
                  />
                )}
                <DropdownMenuItem
                  title={t(field.is_enabled ? "hiring_flow:hide_field" : "hiring_flow:show_field")}
                  onClick={() => onChange({ is_enabled: !field.is_enabled, is_mandatory: false })}
                />
              </HiringFlowRowMenu>
            )}
            <div className="w-10 flex justify-center items-center">
              <FontAwesomeIcon icon="fa-light fa-grip-dots-vertical" />
            </div>
          </Stack>
        </div>
      )}
    </Draggable>
  );
}
